module.exports = __webpack_public_path__ + "media/images/icons/stethoscope-dark-154793fb90b1c03d57d463244a3857e5.svg";